import Phaser from "phaser";
import { cst } from "../helpers/cst";
import buttonBehaviours from "../helpers/button-behaviours";
import GUI from "./gui";

export default class Intro extends Phaser.Scene {
  constructor() {
    super(cst.scenes.intro);
  }

  init(data) {
    this.categories = data.categories;
  }

  preload() {}

  create(data) {
    this.oldScene = data.scene;
    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-rules"
    );

    this.btnNext = this.add
      .image(
        this.cameras.main.width / 2 + 150,
        this.cameras.main.height / 2 + 540,
        "btn-next"
      )
      .setScale(1.5)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnNext, () => {
          if (!this.scene.get(cst.scenes.gui))
            this.scene.add(cst.scenes.gui, GUI, false);
          this.scene.start(cst.scenes.board, { categories: this.categories });
        });
      });

    this.btnBack = this.add
      .image(
        this.cameras.main.width / 2 - 150,
        this.cameras.main.height / 2 + 540,
        "btn-back"
      )
      .setScale(1.5)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnBack, () => {
          this.scene.stop();
          this.scene.start(this.oldScene, {
            scene: cst.scenes.intro,
          });
        });
      });
  }

  upload() {}
}
